import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  NEWSBOARD_POST_FORM_FIELD_NAME_TITLE,
  NEWSBOARD_POST_FORM_TICKER_TITLE_FIELD_MAX_LENGTH,
  NEWSBOARD_POST_FORM_TITLE_FIELD_MAX_LENGTH,
} from '../../NewsboardPostForm.constants'

function TitleField({ ticker }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Newsboard.TitleLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={
        ticker
          ? NEWSBOARD_POST_FORM_TICKER_TITLE_FIELD_MAX_LENGTH
          : NEWSBOARD_POST_FORM_TITLE_FIELD_MAX_LENGTH
      }
      name={NEWSBOARD_POST_FORM_FIELD_NAME_TITLE}
      placeholder={t('Newsboard.TitlePlaceholderKey')}
    />
  )
}

export default TitleField
